module.exports = __webpack_public_path__ + "static/media/cereza.51a40f9a.png";